import { Injectable } from '@angular/core';
import { LocalStorageUtil, UsuarioAutenticado, UsuarioPermissoes } from "ui-shared";

@Injectable({
    providedIn: 'root'
})
export class Rules {
    private readonly permissoes: UsuarioPermissoes;
    private readonly usuarioLogado: UsuarioAutenticado;

    constructor() {
        this.permissoes = JSON.parse(LocalStorageUtil.obterPermissoes());
        this.usuarioLogado = JSON.parse(LocalStorageUtil.obterUsuario());
    }

    /** Controle da classificação por projeto ligado para o cliente (vem de usuario/detalhes, guardado com as permissões). */
    public get controlePorProjeto(): boolean {
        return !!(this.permissoes as UsuarioPermissoes & { controlePorProjeto?: boolean })?.controlePorProjeto;
    }

    /** Projetos: só com o controle ligado e a permissão de cadastro de projeto. */
    public get projetosHabilitados(): boolean {
        return this.controlePorProjeto && this.possuiPermissao(EnumRoles.CadastroProjeto);
    }

    public possuiPermissao(role: string): boolean {
        if (role == EnumRoles.Suporte && this.usuarioLogado && !this.usuarioLogado.suporte) {
            return false;
        }

        if (this.usuarioLogado &&
            (this.usuarioLogado.suporte ||
                this.usuarioLogado.claims.find(claim => claim.type == "administrador")?.value == "True")) {
            return true;
        }

        if (!this.permissoes) {
            return false;
        }

        const possuiPerfilAdministrador = this.permissoes.perfis?.some(perfil =>
            perfil.perfilAcesso == EnumRoles.Administrador);
        const possuiPerfil = this.permissoes.perfis?.some(perfil => perfil.perfilAcesso == role);

        return this.permissoes.administrador || possuiPerfilAdministrador || possuiPerfil;
    };
}

/** Nomes iguais aos de `EnumAcaoClassificacao` (backend e enum do front), mais `Suporte`, que só vale para o claim do usuário. */
export enum EnumRoles {
    Suporte = 'Suporte',
    Detalhes = 'Detalhes',
    HistoricoAcoes = 'HistoricoAcoes',
    HistoricoSugestoes = 'HistoricoSugestoes',
    HistoricoAlteracoes = 'HistoricoAlteracoes',
    IniciarClassificacao = 'IniciarClassificacao',
    SolicitarSugestaoIa = 'SolicitarSugestaoIa',
    DefinirNcmSugerida = 'DefinirNcmSugerida',
    EditarProduto = 'EditarProduto',
    SolicitarInformacoesAdicionais = 'SolicitarInformacoesAdicionais',
    FornecerInformacoesAdicionais = 'FornecerInformacoesAdicionais',
    Validar = 'Validar',
    Administrador = 'Administrador',
    GestaoUsuario = 'GestaoUsuario',
    CadastroProjeto = 'CadastroProjeto',
    CadastroProduto = 'CadastroProduto',
    CancelarSugestaoIa = 'CancelarSugestaoIa',
    DefinirSimilaridade = 'DefinirSimilaridade',
}

export enum EnumCondicional {
    PossuiAlguma = 1,
    PossuiTodas = 2
}
